import View from "../account/views/ChekoutMembershipView";
import components from "./components.js";
components.define("js-CheckoutPage", View);